/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Storefront = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.1297 3.49988L3.59944 8.82579C4.31552 9.99255 5.92645 10.3085 7.03674 9.41675C7.13541 9.33751 7.24116 9.27227 7.3515 9.22092L8.11468 3.49988H5.1297ZM8.96336 9.41683C8.92649 9.38722 8.88857 9.35954 8.84973 9.33379L9.62797 3.49988H14.372L15.1503 9.33379C15.1114 9.35954 15.0735 9.38722 15.0366 9.41683C13.2719 10.8342 10.7281 10.8342 8.96336 9.41683ZM16.6485 9.22092C16.7588 9.27227 16.8646 9.33751 16.9633 9.41675C18.0735 10.3085 19.6845 9.99255 20.4006 8.82578L18.8703 3.49988H15.8853L16.6485 9.22092ZM20 1.99988H4L2 8.96067L2.04518 9.06952C2.28425 9.64556 2.64216 10.1261 3.07556 10.5H3V22L11.5066 21.9996V20.4996L4.5 20.5V11.274C5.645 11.6102 6.94242 11.4164 7.97604 10.5862C7.99003 10.575 8.01006 10.5751 8.02406 10.5863C10.3374 12.4444 13.6626 12.4444 15.9759 10.5863C15.9899 10.5751 16.01 10.575 16.024 10.5862C17.0576 11.4164 18.355 11.6102 19.5 11.274V20.5H18V13.5H13V22H14.5V15H16.5V22H21V10.5H20.9244C21.3578 10.1261 21.7158 9.64556 21.9548 9.06952L22 8.96067L20 1.99988ZM7.5 15H10V17.5H7.5V15ZM6 13.5H11.5V19H6V13.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
